// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__loc9l","container":"Overlay_container__kixr-","autoHeight":"Overlay_autoHeight__YFtEv","closeModal":"Overlay_closeModal__+XXW6"};